<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>我的证书</b>
        <div class="tips">
          您当前共 <i class="uc-blue">{{ list.total_count }}</i> 个证书
        </div>
      </div>
      <div class="right">
        <el-dropdown @command="handleCommand" class="uc-pr0">
          <span class="el-dropdown-link">
            {{ custom }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in dropDownData"
              :key="index"
              :command="{ value: item.val, label: item.label }"
              >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div>
      <section class="g-list">
        <div class="content-empty" v-if="list.total_count == 0">
          <div class="emptyimg-box"></div>
          <p>暂无相关内容</p>
        </div>
        <div
          v-for="(item, index) in list.items"
          :key="index"
          class="item"
          style="position:relative;text-align:center;"
        >
          <a :href="item.cert_url" target="_blank" class="con">
            <div class="img-box">
              <img :src="item.cert_cover" />
            </div>
          </a>
        </div>
      </section>
    </div>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'PersonalCertificate',
  data() {
    return {
      query: {
        certTplType: undefined,
        pageIndex: 1,
        pageSize: 10,
      },
      list: [],
      dropDownData: [
        { label: '全部', val: undefined },
        { label: '课程', val: 1 },
        { label: '考试', val: 2 },
        { label: '培训班', val: 3 },
      ],
      custom: '全部',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getMyCertificates();
    },
    handleCommand(command) {
      this.custom = command.label;
      this.query.certTplType = command.value;
      this.query.pageIndex = 1;
      this.initData();
    },
    async getMyCertificates() {
      const response = await this.$api.certificate.getMyCertificates(
        this.query
      );
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
  },
};
</script>
